import {
  DataRow,
  DataRow as SystemDataRow,
} from "./list/RecorderListContainer";
import * as s from "../RecordersStyled";
import { useState } from "react";
import {
  AuthErrorHelp,
  DetachedHelp,
  IncompleteRegistrationHelp,
} from "../RecorderAlertHelp";
import { WithTooltip } from "components/blocks/WithTooltip";
import { RiAlertFill } from "react-icons/ri";
import { COLORS } from "styles/colors";
import styled from "styled-components";
import useApiError from "hook/useApiError";
import { MergedRecorder } from "api/interfaces/recorderInterface.interface";

type NeedActionCellTye = {
  recorder: DataRow;
};

export const NeedActionCell = ({
  recorder,
}: NeedActionCellTye): JSX.Element => {
  const { hasAuthError, hasDetached, hasIncompleteRegistration } = recorder;
  const isDetached = (recorder.row as MergedRecorder)?.isDetached ?? false;

  if (
    !hasAuthError &&
    !hasDetached &&
    !isDetached &&
    !hasIncompleteRegistration
  ) {
    return <></>;
  }

  return (
    <s.Row>
      <Cell
        onClick={(e) => e.stopPropagation()}
      >
        {hasAuthError && <AuthErrorAlert />}
        {hasIncompleteRegistration && <IncompletRegistrationAlert />}
        {hasDetached && <DetachedAlert />}
        {isDetached && <DetachedAlert />}
      </Cell>
    </s.Row>
  );
};

const AuthErrorAlert = () => {
  const [isHelpVideo, setIsHelpVideo] = useState<boolean>(false);
  const openHelpVideo = () => {
    setIsHelpVideo(true);
  };
  const closeHelpVideo = () => {
    setIsHelpVideo(false);
  };
  const { lang, intlString } = useApiError();

  return (
    <AlertItem>
      <WithTooltip
        tooltip={intlString(lang.label.recorder.tooltip.alert.instruction)}
      >
        <AlertItemText
          onClick={openHelpVideo}
          data-testid="recorders-recorders-recorders-alert-item-text-open-help-video"
        >
          <RiAlertFill /> Admin Password
        </AlertItemText>
      </WithTooltip>
      {isHelpVideo && <AuthErrorHelp onModal={closeHelpVideo} />}
    </AlertItem>
  );
};

const DetachedAlert = () => {
  const [isHelpMessage, setIsHelpMessage] = useState<boolean>(false);
  const openHelpMessage = () => {
    setIsHelpMessage(true);
  };
  const closeHelpMessage = () => {
    setIsHelpMessage(false);
  };

  const { lang, intlString } = useApiError();

  return (
    <AlertItem>
      <WithTooltip
        tooltip={intlString(lang.label.recorder.tooltip.alert.instruction)}
      >
        <AlertItemText
          onClick={openHelpMessage}
          data-testid="recorders-recorders-recorders-alert-item-text-open-help-message"
        >
          <RiAlertFill /> Detached
        </AlertItemText>
      </WithTooltip>
      {isHelpMessage && <DetachedHelp onModal={closeHelpMessage} />}
    </AlertItem>
  );
};

const IncompletRegistrationAlert = () => {
  const [isHelpVideo, setIsHelpVideo] = useState<boolean>(false);
  const openHelpVideo = () => {
    setIsHelpVideo(true);
  };
  const closeHelpVideo = () => {
    setIsHelpVideo(false);
  };

  const { lang, intlString } = useApiError();

  return (
    <AlertItem>
      <WithTooltip
        tooltip={intlString(lang.label.recorder.tooltip.alert.instruction)}
      >
        <AlertItemText
          onClick={openHelpVideo}
          data-testid="recorders-recorders-recorders-alert-item-text-open-help-video-2"
        >
          <RiAlertFill /> Incomplete Registration
        </AlertItemText>
      </WithTooltip>
      {isHelpVideo && <IncompleteRegistrationHelp onModal={closeHelpVideo} />}
    </AlertItem>
  );
};

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  border-radius: 2px;
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.COMPANY : COLORS.WARNING};
  background: ${COLORS.WARNING}05;
  background: linear-gradient(
    90deg,
    ${COLORS.WARNING}30 0%,
    ${COLORS.WARNING}00 100%
  );
`;

const AlertItem = styled.div`
  padding: 1px 2px;
  border-radius: 2px;
  padding-right: 2px;
  transition: all ease-out 0.1s;

  &:hover {
    background: ${COLORS.WARNING}25;
  }
`;

const AlertItemText = styled.div`
  display: flex;
  gap: 4px;
`;
